import React, { ReactElement } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { FormNodePIIModel, piiInputs, PIIType } from '../../../../../shared/kiosk';
import { AbstractElementEditor, UpdateFormProps } from './AbstractElementEditor';
export class PiiEditor extends AbstractElementEditor<FormNodePIIModel> {
  public getDescription(): string {
    return 'User enter personal information';
  }

  public getName(): string {
    return 'Personal Information';
  }

  public getIcon(): string {
    return 'person';
  }

  public override getDefaultValues(): Partial<Omit<FormNodePIIModel, 'id' | 'type'>> {
    return {
      subType: 'realName',
    };
  }

  public override getUpdateForm({
    node,
    update,
    ts,
  }: UpdateFormProps<FormNodePIIModel>): ReactElement {
    return (
      <>
        <FormGroup>
          <Label for="piiInput">{ts('input_type')}</Label>
          <Input
            onChange={(e) => {
              update({ ...node, subType: e.target.value as PIIType });
            }}
            type="select"
            value={node.subType}
          >
            {piiInputs.map((option) => (
              <option key={option.piiType} value={option.piiType}>
                {option.name}
              </option>
            ))}
          </Input>
        </FormGroup>
        {!['regionCountrySelector', 'phoneNumber'].includes(node.subType) && (
          <FormGroup>
            <Label for="piiMarkdown">Markdown</Label>
            <Input
              onChange={(e) => {
                update({ ...node, markdown: e.target.value });
              }}
              rows={15}
              type="textarea"
              value={node.markdown}
            />
          </FormGroup>
        )}
      </>
    );
  }
}
